module.exports = __webpack_public_path__ + "img/42_22.9005eeeb.png";